import { canUseDOM } from "./auth-service-tools646.js";
import { getActiveElement } from "./auth-service-tools453.js";
var isIE11 = canUseDOM && "msCrypto" in window;

function getNextActiveElementOnBlur(event) {
  if (isIE11) {
    var activeElement = getActiveElement(event.currentTarget);
    return activeElement;
  }

  return event.relatedTarget;
}

export { getNextActiveElementOnBlur };